import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface AlignmentProgressProps {
  algorithm: string;
  created: string;
  numSequences: number;
}

function AlignmentProgress({algorithm, created, numSequences}: AlignmentProgressProps): JSX.Element {
  return (
    <tr>
      <td>
        {algorithm} with {numSequences} sequences, started at {created}
      </td>
    </tr>
  );
}

export default makeDeprecatedJadeStyleTemplate<AlignmentProgressProps>(AlignmentProgress);
